import React, { useContext, useState } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import ForgotPassword from './views/Pages/Register/ForgotPassword';
import NewPassword from './views/Pages/Register/NewPassword';
import Context from './store/Context';
import './App.css';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500, Register } from './views/Pages';

import '@coreui/icons/css/coreui-icons.min.css';
import 'flag-icon-css/css/flag-icon.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import './scss/style.css'

function App(props) {
  const [status, setStatus] = useState(0)
  const { jwt, menu } = useContext(Context)

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/login" name="Login Page"><Login status={status} setStatus={setStatus} /></Route>
        <Route exact path="/forgot-password" name="Forgot Password Page" component={ForgotPassword} />
        <Route exact path="/new-password" name="New Password Page" component={NewPassword} />
        <Route exact path="/404" name="Page 404" component={Page404} />
        <Route exact path="/500" name="Page 500" component={Page500} />
        {jwt ? window.location.hash === '#/' ? <Redirect to="/dashboard" /> : <Route path="/" name="Home" component={DefaultLayout} /> : <Redirect to="/login" />}
      </Switch>
    </HashRouter>
  );
}


export default App;


// WEBPACK FOOTER //
// ./src/App.js